const init = { totalCount: 0, roles: [] };

const role = (state = init, action) => {
  switch (action.type) {
    case "ROLE":
      const roles = [];
      for (const role of action.role.roles) {
        if (role.name === "customer") {
          role.totalCount -= 1;
        } else {
          roles.push(role);
        }
      }
      action.role.roles = roles;
      return action.role;
    default:
      return state;
  }
};

export default role;
